module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921064151_T.9315954c.jpg";